<template>
<div class="progress-bar-container progress-text pl-0 pr-0 pt-0 pb-3">
  <div class="progress">
    <div class="progress-bar progress-bar-success" role="progressbar"
      :aria-valuenow="percent_complete"
      aria-valuemin="0" aria-valuemax="100"
      :style=" 'width:'+percent_complete+'%;'">
      <div id="thicker-text" class="justify-content-center position-absolute w-100 pr-2">{{percent_complete}}% Complete</div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  props:{
    percent_complete: String
  },
  data(){
    return{
    }
  },
}
</script>

<style lang="scss" scoped>

#thicker-text{
  color: black;
  font-weight: bold;
}

.progress
{
  height: 35px;
  border-radius: 20px;
  background-color: #fff;
  border: 1px solid #dcdcdc;
}

.progress-bar-success { background-color: #00d000; }

</style>
